export function tab() {
  const tabs = document.querySelectorAll(".js-tab");
  const tabBtns = document.querySelectorAll(".js-tabBtn");
  const cont = document.querySelector(".js-cont");
  const body = document.querySelector("body");

  tabs.forEach(tab => {
    tab.style.display = "none";

    if(tabBtns[0].dataset.target === tab.id) {
      tab.style.display = "block";

      document.querySelectorAll(`.js-tabBtn[data-target="${tabBtns[0].dataset.target}"]`).forEach(item=>{
        item.classList.add("is-active");
      })
    }
  })

  tabBtns.forEach(tabBtn => {
    tabBtn.addEventListener("click", () => {
      
      tabBtns.forEach( item => { item.classList.remove("is-active"); } )
      
      tabs.forEach(tab => {
        tab.style.display = "none";

        if(tabBtn.dataset.target === tab.id) {
          tab.style.display = "block";

          document.querySelectorAll(`.js-tabBtn[data-target="${tabBtn.dataset.target}"]`).forEach(item=>{
            item.classList.add("is-active");
          })
        }
      })


      // body.scrollIntoView({behavior: "smooth"});
      AOS.refreshHard();
      cont.scrollIntoView({behavior: "smooth"});
    })
  })
}
